/**
 * Tuetut valuutat (suunnitelma 7, asetus `currency`).
 *
 * Valuutta on **järjestelmäasetus**, ei kirjauksen, projektin tai
 * asiakkaan ominaisuus: yksi asennus laskuttaa yhdessä valuutassa.
 * Suunnitelma rajaa valuuttamuunnokset ulos (luku 1), joten kahdessa
 * valuutassa kertyneitä summia ei voisi laskea yhteen — ja raportti,
 * jonka loppusummaa ei voi laskea, ei ole raportti.
 *
 * Lista on kuratoitu eikä koko ISO 4217. Sadan kahdeksankymmenen rivin
 * valintalista ei auta ketään löytämään kruunuaan, ja suurin osa koodeista
 * ei koskaan osu tämän järjestelmän käyttäjiin. Uuden valuutan lisääminen
 * on yksi rivi tähän: nimet ja symbolit tulevat `Intl`iltä, ei käsin
 * ylläpidetystä käännöstaulukosta.
 */
export const SUPPORTED_CURRENCIES = [
    // Euroopassa käytössä olevat
    'EUR',
    'SEK',
    'NOK',
    'DKK',
    'ISK',
    'GBP',
    'CHF',
    'PLN',
    'CZK',
    'HUF',
    'RON',
    'BGN',
    // Muualla yleiset
    'USD',
    'CAD',
    'AUD',
    'JPY',
];
/** Valuutta, jolla järjestelmä aloittaa ja johon puuttuva asetus palautuu. */
export const DEFAULT_CURRENCY = 'EUR';
export function isCurrencyCode(value) {
    return typeof value === 'string' && SUPPORTED_CURRENCIES.includes(value);
}
//# sourceMappingURL=currency.js.map